import React from 'react';

import ItemsProviderWithStore, {
	ItemsProviderWithStoreContextActions,
} from '@common/react/components/Core/ItemsProviderWithStore/ItemsProviderWithStore';
import {
	BaseFilters,
	ItemsProviderContext,
	List,
} from '@common/react/components/Core/ItemsProvider/ItemsProvider';

import { AppointmentStatus, SystemAppointmentStatus } from '@app/objects/Appointment';
import { defaultOptions } from '@app/components/UI/AppointmentStatus/defaultOptions';

interface StatusesProviderActions extends ItemsProviderWithStoreContextActions<AppointmentStatus,
	BaseFilters, List<AppointmentStatus>> {
	getStatusWithSAStatus: (saStatus: SystemAppointmentStatus) => AppointmentStatus | null;
}

interface StatusesProviderContext extends ItemsProviderContext<AppointmentStatus,
	BaseFilters, List<AppointmentStatus>, StatusesProviderActions> {}

interface StatusesProviderProps {
	children?: React.ReactNode | ((context: StatusesProviderContext) => React.ReactNode);
}

export const StatusesProvider: React.FC<StatusesProviderProps> = ({ children }) => {
	return <ItemsProviderWithStore<AppointmentStatus>
		{...defaultOptions}
	>
		{(context) =>
			(typeof children === 'function'
				? children({
					...context,
					actions: {
						...context.actions,
						getStatusWithSAStatus: (saStatus) => (context.state.items.find((q) => q.saStatus === saStatus)),
					},
				} as StatusesProviderContext)
				: children)
		}
	</ItemsProviderWithStore>;
};
